import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import Icon from 'presentations/views/components/atoms/Icon';
import Image from 'presentations/views/components/atoms/Image';
import Headline from 'presentations/views/components/atoms/Headline';
import Link from 'presentations/views/components/atoms/Link';
import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { black, primary } from 'presentations/views/styles/color';
import {
  customerStoryListPath,
  resourceCategoryPath,
} from 'presentations/routes/path';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <Container>
      <CompanyTitleContainer>
        <CompanyTitleIcon name="bulb-on-outline" />
        <CompanyTitle variant="h3">{t('company title')}</CompanyTitle>
      </CompanyTitleContainer>
      <CompanyList>
        <Item>
          <LogoImage
            width={100}
            height={36}
            src="pages/top/logos/rgf.png"
            alt={t('rgf')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={392}
            height={36}
            src="pages/top/logos/toyota.png"
            alt={t('toyota')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={82}
            height={28}
            src="pages/top/logos/logo_agc.svg"
            alt={t('agc')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={100}
            height={36}
            src="pages/top/logos/logo_smaregi.svg"
            alt={t('smaregi')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={136}
            height={36}
            src="pages/top/logos/logo_kiyo.png"
            alt={t('kiyo')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={241}
            height={60}
            src="pages/top/logos/logo_17live.svg"
            alt={t('17live')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={172}
            height={28}
            src="pages/top/logos/logo_spacemarket.svg"
            alt={t('spacemarket')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={166}
            height={28}
            src="pages/top/logos/logo_asahi.svg"
            alt={t('asahi')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={264}
            height={56}
            src="pages/top/logos/logo_nyle.png"
            alt={t('nyle')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={123}
            height={28}
            src="pages/top/logos/logo_helpfeel.svg"
            alt={t('helpfeel')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={114}
            height={28}
            src="pages/top/logos/logo_ecrowd.svg"
            alt={t('ecrowd')}
            dpr={2}
          />
        </Item>
        <Item>
          <LogoImage
            width={152}
            height={28}
            src="pages/top/logos/logo_jx.png"
            alt={t('jx')}
            dpr={2}
          />
        </Item>
      </CompanyList>
      <UseCaseContainer>
        <UseCaseMoreIcon name="chevron-right" />
        <UseCaseMoreText href={customerStoryListPath()}>
          {t('usecase more')}
        </UseCaseMoreText>
      </UseCaseContainer>
    </Container>
  );
}

const Container = styled.div``;
const CompanyTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(20)};
`;
const CompanyTitle = styled(Headline)`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(14)};
`;
const CompanyTitleIcon = styled(Icon)`
  color: ${primary};
  margin-right: ${spacing(4)};
  width: 20px !important;
  height: 20px !important;
`;
const UseCaseContainer = styled.div`
  display: flex;
  align-items: center;
`;
const UseCaseMoreIcon = styled(Icon)`
  color: ${primary};
  margin-right: ${spacing(2)};
  width: 18px !important;
  height: 18px !important;
`;
const UseCaseMoreText = styled(Link)`
  color: ${black};
`;
const CompanyList = styled.div`
  margin-bottom: ${spacing(20)};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const Item = styled.div`
  margin-right: ${spacing(20)};
  margin-bottom: ${spacing(16)};
  ${mediaMax.tablet} {
    margin-right: ${spacing(24)};
  }
  :last-of-type {
    margin-right: 0;
  }
`;

const LogoImage = styled(Image)`
  height: auto;
  max-height: 24px;
  width: auto;
`;
